import type { FormStepId } from 'shared/config/formStepId';
import { sendSentryClientErrorOnce } from 'shared/lib';
import { EsiaConnector } from 'shared/lib/EsiaConnector';
import { sendEventAuthorizationError, sendEventAuthorizationSuccess } from 'shared/lib/sendGAEvents';
import { showNotification } from 'shared/lib/showNotification';

import { formQueries } from 'entities/creditForm';
import { addEsiaErrorAttempt, setEsiaStep, setUser } from 'entities/user';

import { ERROR_ESIA_POPUP_MESSAGE_DELAY } from '../../AuthenticationEsia.config';
import { EsiaTextsConfig } from '../../AuthenticationEsia.texts';

const showErrorNotification = (currentAttempt: number) => {
  if (currentAttempt >= 2) {
    return;
  }

  showNotification({
    title: EsiaTextsConfig.error.title,
    subtitle: EsiaTextsConfig.error.buttonTitle,
    type: 'info',
  });
};

export const readDataAfterEsiaSignInThunk =
  (step: FormStepId): ThunkResult<void> =>
  async (dispatch, getState) => {
    const { user } = getState();

    if (user.isLoggedIn && user.account?.isHasEsia) {
      // юзер есть и у него есть ESIA
      return;
    }

    // устанавливаем шаг при каждом нажатии, чтобы знать в каком блоке выводить ошибку
    dispatch(setEsiaStep(step));

    const connector = new EsiaConnector({
      onSuccess: async () => {
        try {
          const [userInfo, data] = await Promise.all([
            dispatch(formQueries.endpoints.getAccountData.initiate()).unwrap(),
            dispatch(formQueries.endpoints.getUserDataAfterEsia.initiate(step)).unwrap(),
          ]);

          if (!data || !userInfo) {
            sendSentryClientErrorOnce('empty data on readDataAfterEsiaSignInThunk', JSON.stringify({ data, userInfo }));
          }

          if (userInfo) {
            dispatch(setUser(userInfo));
            sendEventAuthorizationSuccess('gosuslugi');
          } else {
            showErrorNotification(user.esiaErrorCount);
            dispatch(addEsiaErrorAttempt());
          }
        } catch (e) {
          showErrorNotification(user.esiaErrorCount);
          sendEventAuthorizationError('gosuslugi');
          dispatch(addEsiaErrorAttempt());
        }
      },
      onError: () => {
        showErrorNotification(user.esiaErrorCount);
        sendEventAuthorizationError('gosuslugi');
        dispatch(addEsiaErrorAttempt());
      },
      popupWndShowTimeout: ERROR_ESIA_POPUP_MESSAGE_DELAY,
      popupSize: 620,
      isStrict: true,
    });

    await connector.tryLogin();
  };
